<button mat-icon-button *ngIf="!shareDocumentTagCell && !checkBoxVisible">
    <mat-icon class="gc-edit"  (click)="onEditSupplierClick(params)" >edit</mat-icon>
</button>
<div *ngIf="shareDocumentTagCell && !checkBoxVisible" class="row mx-0">
    <span *ngFor="let item of shareDocumentTagVal" class="mr-1 mt-1 mb-1 sg-cell-value" >
        <span [ngClass]="item !== 'undefined' ? 'shareDocumentTag' : 'none'" *ngIf="item">{{item === 'undefined' ? '' : item}}</span> 
    </span>
</div>
<div *ngIf="checkBoxVisible">
    <mat-checkbox 
      (click)="onCheckBoxClick(params)"></mat-checkbox>
</div>